import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext } from "react";
const DevToolsContext = createContext({});
function DevToolsProvider({ userEmail, children }) {
  const value = useMemo(() => ({ userEmail }), [userEmail]);
  return /* @__PURE__ */ jsx(DevToolsContext.Provider, { value, children });
}
function useDevTools() {
  return useContext(DevToolsContext);
}
function isDevToolsVisible(userEmail) {
  const isDev = false;
  const isEnableDevTools = false;
  return isDev || isEnableDevTools && !!(userEmail == null ? void 0 : userEmail.endsWith("@quebon.com"));
}
export {
  DevToolsProvider,
  isDevToolsVisible,
  useDevTools
};
//# sourceMappingURL=DevToolsContext.js.map
